<template>
    <gofix-card class="cardTable chartOfAccount" fullContent>
        <iframe id="iframepreview" ref="iframepreview" :src="ifsrc" 
        @load="load"
        width="100%" height="1000px"></iframe>
    </gofix-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: 'file-main',
    components: {
    },
    data() {
        return{
            ifsrc: null,
            iframeEl: null
        }
    },
    created() {
        if (!this.$route.params.hasOwnProperty('file_id') || (this.$route.params.file_id != 0 && isNaN(this.$route.params.file_id))) {
            return this.$router.push(this.$route.matched[this.$route.matched.length - 1].parent.path);
        }

        if (this.$route.params.file_id != 0) {
            this.previewFile(this.$route.params.file_id);
        }
    },
    mounted() {
        this.iframeEl=this.$refs.iframepreview;
    },
    methods: {
        load(){
            var iframe = document.getElementById("iframepreview");
            let params = {};
            params.id = this.$route.params.file_id;
            params.jwt_token = localStorage.getItem('access_token');
            params.app_token = "fvedoSam1DJWaq7X78oraW03UBilsXPO";
            let api_host = process.env.VUE_APP_SERVER_URL || 'https://fm-api-dev.gofix.com.sg';
            iframe.contentWindow.postMessage(params,api_host);
            //iframe.contentWindow.postMessage(params,'*');
        },
        async previewFile(attachment_id) {
            let api_host = process.env.VUE_APP_SERVER_URL || 'https://fm-api-dev.gofix.com.sg';
            let url = api_host+"/filepreview/attachment_id";
            this.ifsrc = url;
        }
    }
}
</script>